<template>
  <el-form label-width="150px">
    <el-row>
      <el-col :span="12">
        <el-form-item label="考勤月份：" required>
          <el-date-picker v-model="selectMonth" type="month" placeholder="请选择考勤月份" value-format="YYYY-MM" style="width: 100%"/>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="日期计算范围：" required>
          <el-date-picker v-model="work_date" type="daterange"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          value-format="YYYY-MM-DD" style="width: 100%" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="员工计算范围：" required>
          <el-select v-model="range" placeholder="计算范围"  clearable>
            <el-option v-for="item in rangeList" :key="item.value" :label="item.name" :value="item.value"/>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-show="range === 'department'">
      <el-col :span="24">
        <el-form-item label="部门：" required>
          <el-cascader
              v-model="department_id"
              :show-all-levels="true"
              :options="deptCascader"
              :props="optionProps"
              placeholder="部门"
              clearable
              style="width: 100%"
              @change="deptChange"
          ></el-cascader>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row  v-show="range === 'department'">
      <el-col :span="24">
        <el-form-item label="员工：" required>
          <el-select v-model="employee_ids" placeholder="员工" multiple filterable clearable>
            <el-option v-for="item in employeeList" :key="item.id" :label="item.employee_name" :value="item.id"/>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: center">
        <el-button type="primary" @click="sumMonthReport" :loading="computationLoading" >考勤计算</el-button>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>


export default {
  name: "AttendanceSumForm",
  components: {},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    rangeList(){
      return this.$store.getters['core/getDictList']('attendance_range');
    }
  },
  data() {
    return {
      optionProps: {
        emitPath:false,
        value: 'id',
        label: 'name',
        checkStrictly:true
      },
      selectMonth:'',
      department_id: '',
      range:'',
      value :new Date(),
      work_date:[],
      employeeList:[],
      deptCascader:[],
      employee_ids:[],
      computationLoading: false
    }
  },
  methods: {
    deptChange(){
      this.getEmployeeList();
    },
    async getDepartmentCascader() {
      this.deptCascader = await this.$http("sysUserDepartmentService.getDepartmentData");
    },
    async getEmployeeList() {
      let params = {department_id: this.department_id}
      this.employeeList = await this.$http("employeeInfoService.getAllEmployeeListByDept",params);
    },
    async sumMonthReport() {
      let chkParams = {type:"attendance"}
      await this.$http('attendanceMonthService.checkRunning',chkParams, false).then(() => {
        //计算
        let params = {
          date:this.selectMonth,
          department_id:this.department_id,
          employee_ids:this.employee_ids,
          date_range:this.work_date}
        this.computationLoading = true;
        this.$http('attendanceMonthService.sumMonthReport',params, false).then(() => {
          this.$message.success("计算成功");
          this.computationLoading = false;
        }, errMsg => {
          this.$message.error(errMsg)
          console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          this.computationLoading = false;
        })
      }, errMsg => {
        this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
        this.computationLoading = false;
      })
    },
  },
  created() {
    this.getDepartmentCascader();
    this.getEmployeeList();
  }
}
</script>


<style scoped lang="less">

</style>